import { Box, Card, Stack, Tab, Tabs, Typography, useMediaQuery } from "@mui/material"
import { useState } from "react"
import { BoxImgBadge, StackInfo, TypCategories, TypDescription, TypStatus, TypTitle } from "./style"
import { IconStatus } from "../../../icons/IconStatus"
import { TeamDescriptionProps } from "../../../types/entitys/teams"
import { TeamInfo } from "../TeamInfo"
import { PureLightTheme } from "../../../styles/theme"
import { UserAvatar } from "../../common/UserAvatar"
import { EntityImagePreviewModal } from "../../common/EntityImagePreviewModal"
import { useEntityImagePreview } from "../../common/useEntityImagePreview"
import { TeamProjectsSection } from "../TeamProjectsSection"
import { TabsStyle } from "../../ProjectsPage/ProjectsTabs/style"

export const TeamDescription = ({ team }: TeamDescriptionProps) => {
    const isTablet = useMediaQuery(PureLightTheme.breakpoints.down('md'));
    const isMobile = useMediaQuery(PureLightTheme.breakpoints.down('sm'));
    const [currentTab, setCurrentTab] = useState(0)
    const {
        canPreview,
        openPreview,
        closePreview,
        galleryOpen,
        galleryImages,
    } = useEntityImagePreview(team.image)

    return (
        <Box>
            <Stack direction="row" mb={{ xs: 2.5, sm: 2 }} flexDirection={{ xs: 'column', sm: 'row' }}>
                <Box sx={BoxImgBadge}>
                    <UserAvatar
                        src={team.image}
                        size={150}
                        onClick={canPreview ? openPreview : undefined}
                    />
                </Box>
                <Box>
                    {isMobile && (
                        <Box mb={1}>
                            <UserAvatar
                                src={team.image}
                                size={120}
                                onClick={canPreview ? openPreview : undefined}
                            />
                        </Box>
                    )}
                    <Typography variant="h1" sx={TypTitle}>{team.title}</Typography>
                    <Typography variant="h3" sx={TypStatus}>{team.status} <IconStatus /></Typography>
                    <Stack direction="column" gap={1.5} sx={StackInfo}>
                        <Typography variant="h4" sx={TypDescription}>{team.descriptionShort}</Typography>
                        <Typography variant="h4" sx={TypDescription}>{team.region}, {team.city}</Typography>
                    </Stack>
                </Box>
            </Stack>
            <Stack direction="column" gap={{ xs: 1.5, sm: 2 }} mb={2} sx={{ minWidth: 0 }}>
                <Tabs
                    value={currentTab}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={TabsStyle}
                    onChange={(_event, value) => setCurrentTab(value)}
                >
                    <Tab label="Описание" />
                    <Tab label="Проекты" />
                </Tabs>
            </Stack>
            {currentTab === 0 ? (
                <Stack direction="column" gap={2}>
                    {team.descriptionFull && (
                        <Card variant="primaryAdaptiveCard">
                            <Typography variant="h3" sx={TypCategories}>О команде</Typography>
                            <Typography variant="body1" component="div" sx={{ whiteSpace: 'pre-wrap' }}>{team.descriptionFull}</Typography>
                        </Card>
                    )}
                    {isTablet && <TeamInfo team={team} />}
                    {team.directions.length > 0 && (
                        <Card variant="primaryAdaptiveCard">
                            <Typography variant="h3" sx={TypCategories}>Направления которые изменяют команды</Typography>
                            <Typography variant="body1">{team.directions.join("; ")}</Typography>
                        </Card>
                    )}
                    {team.goals.length > 0 && (
                        <Card variant='primaryAdaptiveCard'>
                            <Typography variant="h3" sx={TypCategories}>Хотим сделать</Typography>
                            <Typography variant="body1">{team.goals.join("; ")}</Typography>
                        </Card>
                    )}
                    {team.projects.length > 0 && (
                        <Card variant='primaryAdaptiveCard'>
                            <Typography variant="h3" sx={TypCategories}>Наши проекты</Typography>
                            <Typography variant="body1">{team.projects.join("; ")}</Typography>
                        </Card>
                    )}
                    {team.resources.length > 0 && (
                        <Card variant='primaryAdaptiveCard'>
                            <Typography variant="h3" sx={TypCategories}>Наши ресурсы</Typography>
                            <Typography variant="body1">{team.resources.join("; ")}</Typography>
                        </Card>
                    )}
                    {team.needs.length > 0 && (
                        <Card variant='primaryAdaptiveCard'>
                            <Typography variant="h3" sx={TypCategories}>Нам нужны</Typography>
                            <Typography variant="body1">{team.needs.join("; ")}</Typography>
                        </Card>
                    )}
                </Stack>
            ) : (
                <TeamProjectsSection teamId={team.id} total={team.linkedProjects} />
            )}
            <EntityImagePreviewModal
                open={galleryOpen}
                onClose={closePreview}
                images={galleryImages}
            />
        </Box>
    )
}
